module.exports = __webpack_public_path__ + "static/media/06.e0c14a12.jpg";